import { EN_FIELD_ERRORS } from '../en/field-errors.ts'

// Italian translation, typed on the source's keys: a covered key must exist in both.
export const IT_FIELD_ERRORS: Readonly<Record<keyof typeof EN_FIELD_ERRORS, string>> = {
  'validation.missing': 'Campo obbligatorio.',
  'validation.string_type': 'Deve essere un testo.',
  'validation.string_too_short': 'Troppo corto: almeno {min_length} caratteri.',
  'validation.string_too_long': 'Troppo lungo: massimo {max_length} caratteri.',
  'validation.string_pattern_mismatch': 'Formato non valido.',
  'validation.int_parsing': 'Deve essere un numero intero.',
  'validation.int_type': 'Deve essere un numero intero.',
  'validation.float_parsing': 'Deve essere un numero.',
  'validation.bool_parsing': 'Deve essere vero o falso.',
  'validation.uuid_parsing': 'Identificativo non valido.',
  'validation.date_parsing': 'Data non valida.',
  'validation.datetime_parsing': 'Data e ora non valide.',
  'validation.greater_than': 'Deve essere maggiore di {gt}.',
  'validation.greater_than_equal': 'Deve essere almeno {ge}.',
  'validation.less_than': 'Deve essere minore di {lt}.',
  'validation.less_than_equal': 'Deve essere al massimo {le}.',
  'validation.enum': 'Valore non ammesso.',
  'validation.tax_code_invalid':
    'Controlla il codice fiscale: l’ultimo carattere non corrisponde agli altri quindici.',
  'validation.color_invalid': 'Questo colore non è valido: sceglilo di nuovo dalla casella.',
  'validation.value_error': 'Valore non valido.',
  'validation.too_short': 'Servono almeno {min_length} elementi.',
  'validation.too_long': 'Al massimo {max_length} elementi.',
}

export const IT_GENERIC_FIELD_ERROR = 'Valore non valido.'
